export const sortAlphabeticallyByField = <T extends Record<string, any>>(
  arr,
  field
): T[] => [...arr].sort((a, b) => a[field]?.localeCompare(b[field]))
